import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getTopic} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'
import {useTopicId} from '../urlParameters/useTopicId'

export const useTopic = () => {
  const plantId = usePlantUpmId()
  const topicId = useTopicId()

  return useQuery({
    queryKey: [QueryKeyName.GetTopic, plantId, topicId],
    queryFn: () => getTopic({plantId, topicId})
  })
}
